import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { colors } from "styles/colors";
import Button from "shared/Button";
import Tabs from "../Tabs";
import { NoImage } from "styles/App.styled";
import { RecipesContext } from "./fragment/RecipesContext";
import { CollectionsContext } from "./fragment/CollectionsContext";
import { pagesName } from "variables/recipesVariables";
import { useSelector } from "react-redux";
import { isLibraryShowPurchasedRecipes } from "store/libraryReducer";

import {
  ProfileInfo,
  TitleUser,
  ProfileButtonWrap,
  CreatorNameWrapper,
  UserLocation,
  MobileHr,
  CreatorName,
  DesktopHr,
  ProfileDesc,
} from "./styled";
import { RecipesPagesSearch } from "../RecipesPagesSearch/RecipesPagesSearch";
import MyInfoImg from "shared/MyInfoImg";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

const ProfileInfoContainer = ({ isOwner, user, page, setActive }) => {
  const router = useRouter();
  const isPurchasedPage = useSelector(isLibraryShowPurchasedRecipes) && page === pagesName.library;

  const isDesktop = useRenderDevice({ min: 769 });

  const tabNavList = [
    {
      id: 1,
      icon: "list",
      text: "Collections",
    },
    {
      id: 2,
      icon: "recipes",
      text: "Recipes",
    },
  ];
  const tabContent = [
    {
      id: 1,
      content: <CollectionsContext page={page} />,
    },
    {
      id: 2,
      content: <RecipesContext page={page} />,
    },
  ];

  return (
    <>
      <ProfileInfo>
        {!user.main_image ? <NoImage className="buyer" /> : <MyInfoImg image={user.main_image} />}
        <CreatorNameWrapper>
          <CreatorName>
            <div>
              <TitleUser>{`${user.first_name} ${user.last_name}`}</TitleUser>
              {user.location && <UserLocation>{user.location}</UserLocation>}
            </div>
          </CreatorName>
          <DesktopHr />
          {isDesktop && (
            <>
              <ProfileDesc>
                <p>{user.bio ? user.bio : ""}</p>
              </ProfileDesc>

              {isOwner && (
                <ProfileButtonWrap>
                  <Link href={`/settings`} passHref>
                    <a>
                      <Button
                        bdButton={colors.WHITE}
                        iconRight="edit"
                        color={colors.RED}
                        textColor={colors.WHITE}
                        text="Edit my profile"
                        stylType="secondary"
                      />
                    </a>
                  </Link>
                </ProfileButtonWrap>
              )}
            </>
          )}
        </CreatorNameWrapper>
      </ProfileInfo>
      <MobileHr style={{ marginTop: "20px" }} />
      {!isDesktop && (
        <>
          <ProfileDesc>
            <p>{user.bio ? user.bio : ""}</p>
          </ProfileDesc>

          {isOwner && (
            <ProfileButtonWrap>
              <Link href={`/settings`} passHref>
                <a>
                  <Button
                    bdButton={colors.WHITE}
                    iconRight="edit"
                    color={colors.RED}
                    textColor={colors.WHITE}
                    text="Edit my profile"
                    stylType="secondary"
                  />
                </a>
              </Link>
            </ProfileButtonWrap>
          )}
        </>
      )}
      {isOwner && router.pathname.includes("/library") && (
        <>
          {isPurchasedPage && <RecipesPagesSearch pageName={page} />}
          <Tabs list={tabNavList} tabContent={tabContent} setTab={setActive} canChangeTab={true} />
        </>
      )}
    </>
  );
};

export default ProfileInfoContainer;
